//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocTypeBasedModel from "../components/DocTypeBasedModel";
import {insightService} from "../insight-service";
import {mapGetters} from "vuex";

export default {
  name: "SelectedModelSidePanel",
  components: {DocTypeBasedModel},
  props: {
    type: {
      type: String
    }
  },
  data: () => ({
    selectedModels: []
  }),
  mounted() {
    this.getModels();
  },
  watch: {
    type: function () {
      this.getModels();
    }
  },
  computed: {
    ...mapGetters(["projectId"])
  },
  methods: {
    getModels() {
      var nuxeo = this.$refs.aiCloudConnect.client;
      insightService
          .getModelsBasedOnType(nuxeo, this.projectId, this.type)
          .then(response => {
            console.log("Models based on type", this.type, response.entries);
            this.selectedModels = response.entries;
          })
          .catch(error => {
            console.error(error);
          });
    }
  }
};
